module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加库存")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.eitSotck
    }
  }, [_vm._v("批量编辑库存")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商品名称"
    },
    model: {
      value: (_vm.params.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "goods_name", $$v)
      },
      expression: "params.goods_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "门店ID"
    },
    model: {
      value: (_vm.params.distribution_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "distribution_id", $$v)
      },
      expression: "params.distribution_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tagsList,
      "height": _vm.wheight - 130,
      "row-key": _vm.getRowKey
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center",
      "label": "全选"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "库存量",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.stock) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distribution_ids",
      "label": "门店号",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.distribution_id) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品"
      }
    }, [
      [
        [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.form.goods_id),
            callback: function($$v) {
              _vm.$set(_vm.form, "goods_id", $$v)
            },
            expression: "form.goods_id"
          }
        }, _vm._l((_vm.GoodsList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)]
      ]
    ], 2), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "库存量"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "库存量"
      },
      model: {
        value: (_vm.form.stock),
        callback: function($$v) {
          _vm.$set(_vm.form, "stock", $$v)
        },
        expression: "form.stock"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "门店编码"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "门店编码"
      },
      model: {
        value: (_vm.form.distribution_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "distribution_id", $$v)
        },
        expression: "form.distribution_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveTagData
      }
    }, [_vm._v("确定保存")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.cancelData
      }
    }, [_vm._v("取消")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.stockDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.stockDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "库存量"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "库存量"
      },
      model: {
        value: (_vm.form.stock),
        callback: function($$v) {
          _vm.$set(_vm.form, "stock", $$v)
        },
        expression: "form.stock"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveStocks
      }
    }, [_vm._v("确定保存")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.cancelData
      }
    }, [_vm._v("取消")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-026c2df0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026c2df0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/jianguan/goods/stock.vue
// module id = 2426
// module chunks = 0